export default "__VITE_ASSET__BpViiPX7__"